import { render } from "./maternity.vue?vue&type=template&id=3927f969"
import script from "./maternity.vue?vue&type=script&lang=js"
export * from "./maternity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__